import { MAIN_GROUP_FIND_MANY } from '../lib/endpoints/category';
import axios from '../lib/axios';
import { MainGroupModel } from '../models/mainGroup';

export const getMainGroupByMerchantId = async ({
  merchantId,
}: {
  merchantId: string;
}): Promise<MainGroupModel[]> => {
  const resData = await axios.post(MAIN_GROUP_FIND_MANY, { filter: { merchant_id: merchantId } });
  return resData?.data?.data;
};
